module.exports = "\n.content { width: calc(100% - 250px); padding: 63px 15px; min-height: 100vh; -webkit-transition: all 0.3s; transition: all 0.3s; position: absolute; top: 0; right: 0; }\n\n.content.active { width: 100%; min-height: 100vh; }\n\na { color: #9ecc45 !important; }\n\na:hover, a:focus  { color: #8ac640 !important; }\n\n@media (max-width: 768px) {\n\n  .content { width: 100%; }\n\n  .content.active { width: -250px; }\n\n  .sidebar { margin-left: -250px; }\n\n  .sidebar.active { margin-left: 0; }\n\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/settings/settings.component.css
// module id = ./src/app/settings/settings.component.css
// module chunks = main